import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import { tickColor, gridColor, baseFont } from './chartConstants';

const LineChart = ({ dailyTicketsChart }) => {
    const chartData = useMemo(() => {
        if (!Array.isArray(dailyTicketsChart) || dailyTicketsChart.length === 0) return null;
        const labels = dailyTicketsChart.map((d, i) => {
            if (i === 0 || i === dailyTicketsChart.length - 1 || i % 5 === 0) {
                const dt = new Date(d.date);
                return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            }
            return '';
        });
        return {
            labels,
            datasets: [{
                label: 'Tickets Created',
                data:  dailyTicketsChart.map(d => d.count),
                fill:  true,
                backgroundColor: 'rgba(99, 102, 241, 0.15)',
                borderColor:     'rgba(99, 102, 241, 1)',
                borderWidth:     2,
                pointRadius:     3,
                pointHoverRadius: 5,
                pointBackgroundColor: 'rgba(99, 102, 241, 1)',
                pointBorderWidth: 0,
                lineTension: 0.35,
            }],
        };
    }, [dailyTicketsChart]);

    const options = useMemo(() => {
        if (!dailyTicketsChart) return {};
        return {
            maintainAspectRatio: false,
            legend: { display: false },
            tooltips: {
                mode: 'index', intersect: false,
                backgroundColor: '#1F2937',
                titleFontFamily: baseFont, titleFontSize: 12, titleFontStyle: 'bold',
                bodyFontFamily: baseFont,  bodyFontSize: 12,
                xPadding: 10, yPadding: 10,
                callbacks: {
                    title: (items) => {
                        const idx = items[0]?.index;
                        if (idx !== undefined && dailyTicketsChart[idx]) {
                            const dt = new Date(dailyTicketsChart[idx].date);
                            return dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
                        }
                        return '';
                    },
                    label: (item) => ` ${item.yLabel} ticket${item.yLabel !== 1 ? 's' : ''}`,
                },
            },
            scales: {
                xAxes: [{ gridLines: { display: false }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, maxRotation: 0, autoSkip: false } }],
                yAxes: [{ gridLines: { color: gridColor }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, beginAtZero: true, callback: (v) => Number.isInteger(v) ? v : null } }],
            },
        };
    }, [dailyTicketsChart]);

    if (!chartData) return <div style={{ color: tickColor, padding: 20 }}>No data for the last 30 days</div>;
    return <div style={{ height: '100%', minHeight: 160 }}><Line data={chartData} options={options} /></div>;
};

export default LineChart;
